export { PersonalInfoSkeleton } from "./personal-info-skeleton";
export { AboutSkeleton } from "./about-skeleton";
export { ExperienceSkeleton } from "./experience-skeleton";
export { EducationSkeleton } from "./education-skeleton";
export { CertificationsSkeleton } from "./certifications-skeleton";
export { SkillsSkeleton } from "./skills-skeleton";
export { LanguagesSkeleton } from "./languages-skeleton";
export { JobsSkeleton } from "./jobs-skeleton";
